import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import BusinessIcon from "@mui/icons-material/Business";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import BadgeIcon from "@mui/icons-material/Badge";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonIcon from "@mui/icons-material/Person";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import HomeIcon from "@mui/icons-material/Home";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { Box } from "@mui/material";

interface FieldConfigItem {
  label: string;
  name: string;
  required: boolean;
  icon: React.ReactNode;
  size: number;
  divider: boolean;
  dividerText?: React.ReactNode;
  optional: boolean;
  selectValues?: string[];
  type?: "text" | "date" | "number" | "select" | "address" | null;
}

const fieldConfig: FieldConfigItem[] = [
  {
    label: "Claim Reference",
    name: "claimReference",
    required: true,
    size: 4,
    icon: null,
    divider: false,
    optional: false,
  },
  {
    label: "Forename",
    name: "firstName",
    size: 4,
    required: false,
    icon: null,
    divider: false,
    optional: false,
  },
  {
    label: "Surname",
    name: "lastName",
    size: 4,
    icon: null,
    divider: false,
    required: false,
    optional: false,
  },
  {
    label: "divider",
    name: "divider",
    size: 12,
    divider: true,
    required: false,
    icon: null,
    optional: false,
  },
  {
    label: "E-mail",
    name: "emailAddress",
    icon: <EmailIcon />,
    size: 3,
    divider: false,
    required: false,
    optional: true,
  },
  {
    label: "Telephone Number",
    name: "telNo",
    icon: <PhoneIcon />,
    size: 3,
    divider: false,
    required: false,
    optional: true,
  },
  {
    label: "Mobile Number",
    name: "mobileTelNo",
    icon: <PhoneAndroidIcon />,
    size: 3,
    divider: false,
    required: false,
    optional: true,
  },
  {
    label: "Passport Number",
    name: "passportNumber",
    size: 3,
    divider: false,
    required: false,
    icon: null,
    optional: true,
  },
  {
    label: "NI Number",
    name: "nationalInsuranceNumber",
    size: 3,
    divider: false,
    required: false,
    icon: null,
    optional: true,
  },
  {
    label: "Driving License",
    name: "drivingLicenseNumber",
    size: 3,
    divider: false,
    required: false,
    icon: null,
    optional: true,
  },
  {
    label: "Vehicle Registration",
    name: "registrationNumber",
    size: 3,
    divider: false,
    required: false,
    icon: null,
    optional: true,
  },
  {
    label: "VIN Number",
    name: "vehicleIdentificationNumber",
    size: 3,
    divider: false,
    required: false,
    icon: null,
    optional: true,
  },
];

const advancedFieldConfig: FieldConfigItem[][] = [
  [
    {
      label: "Claim Information",
      name: "Claim Information Divider",
      size: 12,
      divider: true,
      required: false,
      icon: null,
      optional: false,
      dividerText: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AssignmentIcon sx={{ color: "primary.main" }} />
          <strong>Claim Information</strong>
        </Box>
      ),
    },
    {
      label: "Claim Reference",
      name: "claimReference",
      required: true,
      size: 4,
      icon: null,
      divider: false,
      optional: false,
    },
    {
      label: "Incident Date",
      name: "incidentDate",
      required: false,
      size: 3,
      icon: null,
      divider: false,
      optional: false,
      type: "date",
    },
  ],

  [
    {
      label: "Person Information",
      name: "Person Information Divider",
      size: 12,
      divider: true,
      required: false,
      icon: null,
      optional: false,
      dividerText: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PersonIcon sx={{ color: "primary.main" }} />
          <strong>Person Information</strong>
        </Box>
      ),
    },
    {
      label: "Forename",
      name: "firstName",
      size: 3,
      required: false,
      icon: null,
      divider: false,
      optional: false,
    },
    {
      label: "Middle Names",
      name: "middleNames",
      size: 3,
      required: false,
      icon: null,
      divider: false,
      optional: false,
    },
    {
      label: "Surname",
      name: "lastName",
      size: 3,
      icon: null,
      divider: false,
      required: false,
      optional: false,
    },
    {
      label: "Date of Birth",
      name: "dateOfBirth",
      size: 3,
      icon: null,
      divider: false,
      required: false,
      optional: false,
      type: "date",
    },
  ],
  [
    {
      label: "Person ID Information",
      name: "Person ID Information Divider",
      size: 12,
      divider: true,
      required: false,
      icon: null,
      optional: false,
      dividerText: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FingerprintIcon sx={{ color: "primary.main" }} />
          <strong>Person ID Information</strong>
        </Box>
      ),
    },
    {
      label: "Driving License",
      name: "drivingLicenseNumber",
      size: 3,
      divider: false,
      required: false,
      icon: null,
      optional: true,
    },
    {
      label: "NI Number",
      name: "nationalInsuranceNumber",
      size: 3,
      divider: false,
      required: false,
      icon: null,
      optional: true,
    },
    {
      label: "Passport Number",
      name: "passportNumber",
      size: 3,
      divider: false,
      required: false,
      icon: null,
      optional: true,
    },
    {
      label: "E-mail",
      name: "emailAddress",
      icon: <EmailIcon />,
      size: 3,
      divider: false,
      required: false,
      optional: true,
    },
    {
      label: "Telephone Number",
      name: "telNo",
      icon: <PhoneIcon />,
      size: 4,
      divider: false,
      required: false,
      optional: true,
    },
    {
      label: "Mobile Number",
      name: "mobileTelNo",
      icon: <PhoneAndroidIcon />,
      size: 4,
      divider: false,
      required: false,
      optional: true,
    },
  ],
  [
    {
      label: "Address Information",
      name: "Address Information Divider",
      size: 8,
      divider: true,
      required: false,
      icon: null,
      optional: false,
      dividerText: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <HomeIcon sx={{ color: "primary.main" }} />
          <strong>Address Information</strong>
        </Box>
      ),
    },
    {
      label: "Enter Postcode",
      name: "address",
      size: 12,
      required: false,
      icon: null,
      divider: false,
      optional: false,
      type: "address",
    },
  ],
  [
    {
      label: "Vehicle Information",
      name: "Vehicle Information Divider",
      size: 12,
      divider: true,
      required: false,
      icon: null,
      optional: false,
      dividerText: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DirectionsCarIcon sx={{ color: "primary.main" }} />
          <strong>Vehicle Information</strong>
        </Box>
      ),
    },
    {
      label: "Registration Number",
      name: "registrationNumber",
      size: 4,
      divider: false,
      required: false,
      icon: null,
      optional: true,
    },
    {
      label: "VIN Number",
      name: "vehicleIdentificationNumber",
      size: 4,
      divider: false,
      required: false,
      icon: null,
      optional: true,
    },
  ],
  [
    {
      label: "Organisation Information",
      name: "Organisation Information Divider",
      size: 12,
      divider: true,
      required: false,
      icon: null,
      optional: false,
      dividerText: (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <BusinessIcon sx={{ color: "primary.main" }} />
          <strong>Organisation Information</strong>
        </Box>
      ),
    },
    {
      label: "Organisation Name",
      name: "organisationName",
      size: 6,
      divider: false,
      required: false,
      icon: <BusinessIcon />,
      optional: true,
    },
    {
      label: "Organisation Type",
      name: "organisationType",
      size: 6,
      divider: false,
      required: false,
      icon: <AccountBalanceIcon />,
      optional: false,
      type: "select",
      selectValues: [
        "Storage Provider",
        "Credit Hire Organisation",
        "Medical Practice",
        "Law Firm",
        "Other",
      ],
    },
    {
      label: "Organisation Postcode",
      name: "organisationPostCode",
      size: 4,
      divider: false,
      required: false,
      icon: <LocationCityIcon />,
      optional: false,
    },
    {
      label: "Companies House Number",
      name: "organisationHouseNumber",
      size: 4,
      divider: false,
      required: false,
      icon: <BadgeIcon />,
      optional: false,
    },
    {
      label: "GMC Registration Number",
      name: "organisationGmcNumber",
      size: 4,
      divider: false,
      required: false,
      icon: <MedicalServicesIcon />,
      optional: false,
    },
  ],
];

export { fieldConfig, advancedFieldConfig };
